import { useV2CurrentAccount } from '@ferreri/minato-auth-react';
import { sendWebViewEvent } from '@ferreri/prever-component-lib';
import { useRouter } from 'next/router';
import { useEffect } from 'react';

export const useSendAccountToWebView = () => {
  const router = useRouter();
  const { data, isFetching } = useV2CurrentAccount();

  useEffect(() => {
    if (data && !isFetching && router.isReady) {
      sendWebViewEvent({ event: 'account', data });
    }
  }, [data, isFetching, router.isReady]);
};
